import "./roadblock.scss";
import gif from "./assets/rb.gif";
import title from "./assets/title.png";
import one from "./assets/stills/one.jpg";
import two from "./assets/stills/two.jpg";
import three from "./assets/stills/three.jpg";
import four from "./assets/stills/four.jpg";
import five from "./assets/stills/five.jpg";
import logos from "./assets/logos.png";
import radio from "./assets/radio.png";
import socialspots from "./assets/socialspots.png";
import time from "./assets/time.png";
import { useState } from "react";
import FsLightbox from "fslightbox-react";
import { fade, childFade } from "../fade.js";
import { motion } from "framer-motion";
const videoUrl =
  "https://prismic-io.s3.amazonaws.com/goodstuph/fcde00ac-82be-4d9b-97ab-c3506effd3d6_rb.mp4";

const Roadblock = () => {
  const [controller, setController] = useState({ t: false, s: 1 });
  return (
    <section class="section roadblock">
      <motion.img
        src={title}
        alt="Taking over every screen in Jakarta"
        className="title"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      />
      <motion.p
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        18 hours before the Season 5 premiere, the Professor sent a 30s message
        to his fans in one of the largest coordinated media hijacks the city has
        ever seen. The media hijack happened at precisely 8pm across social,
        digital, radio and OOH platforms—including one of the world’s largest
        LED billboards.
      </motion.p>
      <motion.div
        className="gif-holder"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <img src={time} alt="Time" className="time" />
        <motion.img
          src={gif}
          alt="Roadblock Gif"
          className="gif"
          variants={fade}
          initial="hide"
          whileInView="show"
          viewport={{ once: true }}
        />
        <div className="row">
          <img src={socialspots} alt="Social Spots" className="socials" />
          <img src={logos} alt="TV Channel List" className="logos" />
          <img src={radio} alt="Radio" className="radio" />
        </div>
      </motion.div>
      <motion.video
        controls
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <source src={videoUrl} type="video/mp4" />
      </motion.video>
      <motion.div
        className="stills"
        variants={fade}
        initial="hide"
        whileInView="show"
        viewport={{ once: true }}
      >
        <motion.img
          src={one}
          alt="Still"
          className="one"
          onClick={() => setController({ t: !controller.t, s: 1 })}
          variants={childFade}
          key="1"
        />
        <motion.img
          src={two}
          alt="Still"
          onClick={() => setController({ t: !controller.t, s: 2 })}
          variants={childFade}
          key="2"
        />
        <motion.img
          src={three}
          alt="Still"
          onClick={() => setController({ t: !controller.t, s: 3 })}
          variants={childFade}
          key="3"
        />
        <motion.img
          src={four}
          alt="Still"
          onClick={() => setController({ t: !controller.t, s: 4 })}
          variants={childFade}
          key="4"
        />
        <motion.img
          src={five}
          alt="Still"
          onClick={() => setController({ t: !controller.t, s: 5 })}
          variants={childFade}
          key="5"
        />
        <FsLightbox
          toggler={controller.t}
          sources={[one, two, three, four, five]}
          slide={controller.s}
        />
      </motion.div>
    </section>
  );
};

export default Roadblock;
